module.exports = __webpack_public_path__ + "static/media/diktat-11.97600d93.mp3";